var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-icon",style:({
    margin: _vm.noMargin?'0px':'2px',
    width: _vm.size?`${parseInt(_vm.size)+2}px`: '18px',
    height: _vm.size?`${parseInt(_vm.size)+2}px`: '18px',
    background: `url(${_vm.src}) center center / cover no-repeat`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }